if (!customElements.get('header-drawer')) {
  customElements.define('header-drawer', class extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');

      if (!this.details) return;

      const summary = this.details.querySelector('summary');
      const drawer = this.details.querySelector('#menu-drawer');

      summary?.addEventListener('click', (event) => {
        // Evitamos la acción por defecto del summary para que solo nosotros controlemos
        // el estado 'open' y así no haya doble toggle.
        event.preventDefault();

        const isOpen = this.details.hasAttribute('open');

        if (isOpen) {
          this.details.removeAttribute('open');
        } else {
          this.details.setAttribute('open', '');
          // mejor usar property open por compatibilidad:
          // this.details.open = true;
          drawer?.focus();
        }
      });
    }
  });
}
